import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './LinkModal.css';

const LinkModal = ({ isOpen, onClose, onSubmit, initialText = '', initialUrl = '' }) => {
  const [text, setText] = useState(initialText);
  const [url, setUrl] = useState(initialUrl);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setText(initialText);
      setUrl(initialUrl);
    }
  }, [isOpen, initialText, initialUrl]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (url.trim()) {
      onSubmit({ text: text.trim(), url: url.trim() });
      handleClose();
    }
  };

  const handleClose = () => {
    setText('');
    setUrl('');
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not its children
    if (e.target === modalRef.current) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  // Use portal to render modal outside the form hierarchy
  return ReactDOM.createPortal(
    <div 
      ref={modalRef}
      className="link-modal-overlay" 
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
    >
      <div className="link-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="link-modal-header">
          <h3>Insert Link</h3>
          <button 
            type="button" 
            className="link-modal-close" 
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="link-modal-body">
            <div className="link-modal-field">
              <label htmlFor="link-text">Link Text</label>
              <input
                id="link-text"
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Enter text to display"
                autoFocus
              />
            </div>
            
            <div className="link-modal-field">
              <label htmlFor="link-url">URL</label>
              <input
                id="link-url"
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com"
                required
              />
            </div>
          </div>
          
          <div className="link-modal-footer">
            <button 
              type="button" 
              className="link-modal-button link-modal-button-secondary" 
              onClick={handleClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="link-modal-button link-modal-button-primary"
              disabled={!url.trim()}
            >
              Insert Link
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default LinkModal;
